// The name a COMMAND thread gets the moment an operation starts in it.
//
// A question thread is named after the question (chat.js#titleFor, then the
// model's summarizeTitle). A command thread used to be named after the first
// message too — which is the operation's label, so the history drawer read
// "Initial outreach — 50 new leads" five times in a row and the only way to
// tell Monday's run from Thursday's was to open both. The user's rule
// (2026-08-25): command threads are named with the DAY, in the shape
// "Sept 8th, 2026".
//
// LOCAL calendar day, deliberately — not America/Chicago like the cadence
// arithmetic. A thread name is a diary entry for the person looking at their
// own history drawer, and "the run I did this morning" should carry the date
// that person's wall clock showed. The cadence engine never reads titles, so
// the two conventions cannot disagree anywhere it counts.
//
// Pure module: no imports, no React, no Date.now() at module scope —
// node-testable as-is (scripts/test-threadTitle.mjs).

// AP-style month abbreviations, matching the user's example ("Sept", not the
// Intl "Sep"): short months abbreviate, March–July are written out.
const TITLE_MONTHS = [
  'Jan', 'Feb', 'March', 'April', 'May', 'June',
  'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec',
]

// 1 → "1st", 22 → "22nd", and the 11th–13th exception every ordinal rule has.
function ordinalDay(day) {
  const tens = day % 100
  if (tens >= 11 && tens <= 13) return `${day}th`
  const unit = day % 10
  return `${day}${unit === 1 ? 'st' : unit === 2 ? 'nd' : unit === 3 ? 'rd' : 'th'}`
}

/** "Sept 8th, 2026" for the local calendar day containing `now`. */
export function commandDay(now = new Date()) {
  const d = now instanceof Date && !Number.isNaN(now.getTime()) ? now : new Date(now || Date.now())
  const at = Number.isNaN(d.getTime()) ? new Date() : d
  return `${TITLE_MONTHS[at.getMonth()]} ${ordinalDay(at.getDate())}, ${at.getFullYear()}`
}

/**
 * "Initial outreach — Texas — Sept 8th, 2026", "Follow-Up — Sept 8th, 2026".
 *
 * The label's descriptor half ("— 50 new leads", "— due touches") is dropped:
 * the thread list column is ~44 characters and the date must never be the part
 * that truncates away — it is the whole reason the title exists.
 */
export function commandThreadTitle(label, scopeName = '', now = new Date()) {
  const base = String(label || '').split('—')[0].trim() || 'Operation'
  const scope = String(scopeName || '').trim()
  return `${base}${scope ? ` — ${scope}` : ''} — ${commandDay(now)}`
}
